import React from 'react'
import "./Contact.css"
import { MdCall } from 'react-icons/md'
import { BsFillChatDotsFill } from 'react-icons/bs'
import { HiChatBubbleBottomCenter } from 'react-icons/hi2'

function Contact() {
  return (
   <section className='c-wrapper'>
    <div className='paddings innerWidth flexCenter c-container'>
        {/* left */}
        <div className='flexColStart c-left'>
         <span className='orangeText'>Contact</span>
         <span className='primaryText'>Easy To Contact Us</span>
         <span className='secondaryText'>We always ready to help by providing the best service belive a
             good place to live can make sure life better </span>


       <div className='flexColStart contactModes'>
        <div className='flexStart row'>
            <div className='flexColCenter mode'>
                <div className='flexStart'>
                    <div className='flexCenter icon'>
                        <MdCall size={25}/>
                    </div>
                    <div className='flexColStart detail'>
                        <span className='primaryText'>Call</span>
                        <span className='secondaryText'>021 123 145 14</span>
                    </div>
                </div>
                <div className='flexCenter button'>Call Now</div>
            </div>
            {/* second */}
            <div className='flexColCenter mode'>
                <div className='flexStart'>
                    <div className='flexCenter icon'>
                        <BsFillChatDotsFill size={25}/>
                    </div>
                    <div className='flexColStart detail'>
                        <span className='primaryText'>Chat</span>
                        <span className='secondaryText'>021 123 145 14</span>
                    </div>
                </div>
                <div className='flexCenter button'>Chat Now</div>
            </div>
        </div>
        {/* second row */}
        <div className='flexStart row'>
            <div className='flexColCenter mode'>
                <div className='flexStart'>
                    <div className='flexCenter icon'>
                        <BsFillChatDotsFill size={25}/>
                    </div>
                    <div className='flexColStart detail'>
                        <span className='primaryText'>Video Call</span>
                        <span className='secondaryText'>021 123 145 14</span>
                    </div>
                </div>
                <div className='flexCenter button'>Vido Call Now</div>
            </div>
            {/* fourth */}
            <div className='flexColCenter mode'>
                <div className='flexStart'>
                    <div className='flexCenter icon'>
                        <HiChatBubbleBottomCenter size={25}/>
                    </div>
                    <div className='flexColStart detail'>
                        <span className='primaryText'>Message</span>
                        <span className='secondaryText'>021 123 145 14</span>
                    </div>
                </div>
                <div className='flexCenter button'>Chat Now</div>
            </div>
        </div>
       </div>
        </div>
        <div className='c-rigth'>
            <div className='image-container'>
                <img src='./contact.jpg' alt=''/>
            </div>
        </div>
    </div>
   </section>
  )
}

export default Contact
